import React from 'react'
import {
  LoaderSwitcher,
  MerchantCategoriesLoader,
  MerchantModifierGroupsLoader,
  StoreOrderTypeCapacityLoader
} from 'router/Loaders'
import LocationDashboard from 'components/Locations/Dashboard'

export const LocationDashboardWrapper = () => {
  return (
    <MerchantCategoriesLoader>
      {(isParentLoaded) => (
        <MerchantModifierGroupsLoader isParentLoaded={isParentLoaded}>
          {(isParentLoaded) => (
            <StoreOrderTypeCapacityLoader isParentLoaded={isParentLoaded}>
              {(isParentLoaded) => (
                <LoaderSwitcher isParentLoaded={isParentLoaded}>
                  <LocationDashboard />
                </LoaderSwitcher>
              )}
            </StoreOrderTypeCapacityLoader>
          )}
        </MerchantModifierGroupsLoader>
      )}
    </MerchantCategoriesLoader>
  )
}
